import { LOANREQUEST_BUCKETS } from 'cpool-constants';
import { z } from 'zod';

import type { EventSchema } from '../../utils/EventSchema';
import { _Event } from '../_Event';

export class User_BucketAdded extends _Event {
    constructor(payload: EventSchema<User_BucketAdded>, deprecated = false) {
        super(payload, deprecated);
    }

    getSchema() {
        return z.object({
            type: z.nativeEnum(LOANREQUEST_BUCKETS),
        });
    }

    static example(): EventSchema<User_BucketAdded> {
        return {
            type: LOANREQUEST_BUCKETS.PK,
        };
    }
}

// const yup = require('yup');

// const Event = require('../_Event');
// const LoanRequest_Classified = require('../LoanRequest/LoanRequest_Classified');

// export class User_BucketAdded extends Event {
// 	static get SCHEME() {
// 		return yup.object({
// 			type: yup.string().oneOf(LoanRequest_Classified.CLASSES).required(),
// 		});
// 	}
// }

// module.exports = User_BucketAdded;
